import * as React from 'react';

import { cn } from '../../lib/utils';

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, ...props }, ref) => (
  <textarea
    className={cn(
      'h-[120px] p-[10px] rounded-[4px]',
      'bg-white border border-[#e0e0e0]',
      'text-[14px] text-[#030303] placeholder:text-[#999999]',
      'focus:outline-none focus:border-[#0265ff] focus:ring-0',
      'disabled:bg-[#eff0f6] disabled:cursor-not-allowed disabled:opacity-100',
      'dark:bg-background dark:border-border dark:text-foreground dark:placeholder:text-muted-foreground',
      'dark:disabled:bg-[oklch(0.279_0.041_260.031)]',
      'resize-none',
      'w-full',
      className
    )}
    ref={ref}
    {...props}
  />
));
Textarea.displayName = 'Textarea';

export { Textarea };
